module.exports = __webpack_public_path__ + "img/mutationpoints.eac2a87c.gif";